
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/velkomin-i-vidskipti",
      function () {
        return require("private-next-pages/velkomin-i-vidskipti.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/velkomin-i-vidskipti"])
      });
    }
  